var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BTooltip", { attrs: { label: _vm.label, type: "is-info" } }, [
    !_vm.disabled
      ? _c(
          "a",
          { staticClass: "button is-info is-rounded is-small" },
          [_c("BIcon", { attrs: { icon: "help", size: "is-small" } })],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }